import { ChebyshevCoefficients } from '@ootk/src/interpolator/ChebyshevCoefficients';
import { Seconds } from '@ootk/src/main';

export const orcusChebyshevCoeffs: ChebyshevCoefficients[] = [
  new ChebyshevCoefficients(
    631152000 as Seconds,
    788940000 as Seconds,
    new Float64Array([
      -9239274937.6297569, -229161094.81381696, 3051171.150334104, 22972.510181585949, -9047.4296442349751, 438.89369856516521, -512.82344573338821, 164.63216644922892,
      -157.62250475883485, -150.68749426205952, 507.64845946629839, 1.3940287748972575,
    ]),
    new Float64Array([
      10432980731.248377, -142514558.67300349, -3201994.9638490994, 73500.992924276987, 589.39776252110801, -617.57608976364133, 93.312183125813803, -6.6778351783752443,
      115.68832715352376, 83.906020768483472, -151.47867797215778, -75.324240938822427,
    ]),
    new Float64Array([
      646523916.54369688, -153559100.516572, -214407.56721808514, 37754.448965330921, 557.46412046949069, -377.47142175634701, 66.941994216044748, -169.7774196823438,
      -68.066033484538394, 205.73612082203229, -50.962355830272038, -166.04993573824564,
    ])
  ),
  new ChebyshevCoefficients(
    788940000 as Seconds,
    946728000 as Seconds,
    new Float64Array([
      -10107989315.636671, -205471919.49884319, 2747983.4073752402, -37368.861414400737, 6649.4238768259684, 2215.7897192319233, -551.04245812098179, 19.228859901428223,
      -323.77611745198567, -152.05232219696046, 600.72709843317671, 61.954125626881918,
    ]),
    new Float64Array([
      9816080758.0136032, -165515813.33516935, -2720989.9142081263, -22515.669075425467, -9482.1473101615902, 921.78404067357383, 120.63519458770752, 139.63381074269611,
      -16.068268076578775, -18.113149674733478, 132.68824106852213, -72.552410634358722,
    ]),
    new Float64Array([
      31237401.659224439, -153835517.88102359, 73278.196866152677, -2951.3465278089047, -4004.6425853947799, 175.53740571637948, 182.80157551964123, -96.280759607752159,
      -269.3329760392507, 85.938510535160702, 108.70325824817021, 23.027005624771117,
    ])
  ),
  new ChebyshevCoefficients(
    946728000 as Seconds,
    1104516000 as Seconds,
    new Float64Array([
      -10884618302.239466, -182397166.0416894, 3242132.1977212271, 71032.561264673874, -7451.826683743795, -886.74811150232949, -277.83622697194414, -109.57880481084187,
      -403.57961966196694, 127.81024395624796, 693.58108638127646, -32.356859874725345,
    ]),
    new Float64Array([
      9108273620.7084503, -188564199.87999099, -2887177.4256572085, 50036.078266843157, 7998.2510356903076, -771.20603520075474, -29.543204243977865, -189.82563619613649,
      40.143113867441812, -69.53580792744954, 21.038116455078125, 87.375961780548096,
    ]),
    new Float64Array([
      -583497288.08903086, -153564435.38885728, 54307.650300597154, 24625.714724319179, 3851.7936497916776, -333.1770818988482, 117.04709906776746, -6.26128383676211,
      -193.97746614813803, -84.13600195050239, 110.49611127177874, 65.649246180057531,
    ])
  ),
  new ChebyshevCoefficients(
    1104516000 as Seconds,
    1262304000 as Seconds,
    new Float64Array([
      -11559925333.198689, -155170508.3409318, 3349863.7068371456, -46628.512655417122, -5084.4589965184532, 688.29352598190303, -315.43198674519857, 28.858192539215086,
      -323.20063470204673, 70.753014469146734, 555.49982255299881, -31.454301611582437,
    ]),
    new Float64Array([
      8312793823.9032469, -208513780.81860223, -2121905.3838910419, 39067.2349094073, -8232.1984373410542, -764.72691583633423, 304.83767747879028, -34.862510347366332,
      64.366000604629519, 14.367375405629476, -218.8329742113749, 28.643515173594157,
    ]),
    new Float64Array([
      -1194451047.9981868, -151584150.92212048, 435889.03012732667, 22191.749083312352, -3284.2875648359459, -283.14306836326915, 218.93984976013502, 178.0205845316251,
      -169.04991634686789, -153.30234293142954, -4.50082456668218, 89.781777695814768,
    ])
  ),
  new ChebyshevCoefficients(
    1262304000 as Seconds,
    1420092000 as Seconds,
    new Float64Array([
      -12129440872.137524, -129696189.47730449, 3252202.6395180384, 69470.79499912262, 5379.2899959564211, -2464.8889388720195, -866.22006429036458, 147.46716550191243,
      -257.94619541168214, -3.9551897684733071, 612.84395716985068, 25.038759358723958,
    ]),
    new Float64Array([
      7444642728.9164486, -225746740.75041863, -2296511.504106299, -9539.7237711270645, 11270.969754711787, 567.06967037518814, -206.2995452562968, -72.428900925318402,
      -94.850242900848386, 181.70404251416525, -56.474309174219769, -149.06364161173502,
    ]),
    new Float64Array([
      -1793491317.5141544, -147971219.03867295, 413547.50945374172, -1913.0284502585728, 4535.2414707740145, 371.23806587457659, -78.409479407469433, 207.34988058408101,
      0.085999993483225498, -118.60103784799576, 28.128431049982705, 46.560751279195152,
    ])
  ),
  new ChebyshevCoefficients(
    1420092000 as Seconds,
    1577880000 as Seconds,
    new Float64Array([
      -12591727719.291792, -101019810.08394572, 3744223.5905847866, -15997.218551794687, -8007.0084720929462, 124.31726922988891, -981.29186124801629, -292.49134070078532,
      -269.42370487848916, 155.37092571258546, 757.33605737686162, 76.497259457906083,
    ]),
    new Float64Array([
      6507614923.0953169, -242227809.03838691, -1683272.2672821998, 69808.707487805688, -2869.1576868216198, -930.5022934913635, -57.726927502950033, 25.458203109105426,
      -66.876054112116492, 32.618309291203815, 140.61169118881224, 20.967818848292033,
    ]),
    new Float64Array([
      -2377411064.9081659, -143730246.98797232, 710066.63432866335, 33824.634323243299, -1350.9474977850914, -163.59055322011312, -45.975521433353421, 271.27264105876287,
      145.34241435925165, -143.10947000583013, -14.266786094506582, -69.017276144027704,
    ])
  ),
  new ChebyshevCoefficients(
    1577880000 as Seconds,
    1735668000 as Seconds,
    new Float64Array([
      -12938835413.697113, -72956857.289452195, 3284306.8933078768, -350.37302061716713, 13366.829146575927, 503.4802296002706, -1186.9670779546102, -144.49864695866901,
      -136.5399087270101, 88.051300843556717, 536.8042882283529, 22.639814535776775,
    ]),
    new Float64Array([
      5514673307.9768429, -254089577.90275586, -1505237.9554907163, -44745.43097887039, -1385.1248841444651, 2181.5286293983459, 129.48537886937459, -158.72844602266946,
      -100.73136515617371, -56.180681339899699, 23.434689203898113, 96.15004528363545,
    ]),
    new Float64Array([
      -2939385269.0886326, -137146589.29738048, 838916.00358223915, -16009.140981403987, -1223.8743977069855, 977.87064332167301, -42.66866059303284, -34.058762311935425,
      166.54347453912098, -28.018562706311542, -133.25603009859719, 25.689750885963438,
    ])
  ),
  new ChebyshevCoefficients(
    1735668000 as Seconds,
    1893456000 as Seconds,
    new Float64Array([
      -13174715877.947336, -44425285.282044917, 3897203.4437192916, 32486.290026315051, -9057.9905196507771, 367.33827358881632, -806.93012081782024, -39.256484794616696,
      -13.532706260681152, -99.689446798960361, 540.96371335983281, 64.363145923614496,
    ]),
    new Float64Array([
      4473142651.4325781, -266572222.46766934, -1379576.8638699213, 69946.714924271902, 2875.8138177235919, -946.67016847928369, 126.88493892351786, 203.26450600624085,
      -11.35858645439148, -123.83035197257995, -125.62709263165792, 45.030202023188274,
    ]),
    new Float64Array([
      -3474856483.9138856, -130527301.59848623, 914768.8298354228, 32189.47429833412, 1242.4931225299836, -483.6610232035319, -59.609258882204692, -82.198033197720846,
      231.57205983002981, 71.203859122594196, -165.19938485622407, -8.5427034775416057,
    ])
  ),
  new ChebyshevCoefficients(
    1893456000 as Seconds,
    2051244000 as Seconds,
    new Float64Array([
      -13290398620.816469, -13650021.842438634, 3634675.057567501, -52044.551060009006, 2283.6758440017702, 2147.8462965329486, -709.52828960418697, -152.57393786112468,
      -325.32938989003497, -76.565555349985758, 771.33692248662317, 144.32212155659994,
    ]),
    new Float64Array([
      3389649217.0399346, -274637111.80780578, -760330.945733428, -162.50844499270121, -9934.1568656206127, 199.8722163438797, 215.74130515257517, 90.901243281364444,
      48.735899774233502, 30.383304150899249, -32.646218776702881, -102.28111426035564,
    ]),
    new Float64Array([
      -3980024874.0402584, -121794059.3902977, 1218641.4075369677, 3888.9974348227183, -4356.8266236305235, -49.802459581693014, -13.711886143684387, -219.79933135509489,
      81.985500502586362, 159.74214154084524, -84.727784204483029, -76.651198657353717,
    ])
  ),
  new ChebyshevCoefficients(
    2051244000 as Seconds,
    2209032000 as Seconds,
    new Float64Array([
      -13287307978.29994, 15425044.542771213, 3891623.6864827154, 71555.114872423801, -5049.568810272217, -1433.6581395785013, -425.16187690099082, 76.203280989329016,
      -428.28869609832765, 7.3443899154663086, 756.85302588144941, -46.548869037628172,
    ]),
    new Float64Array([
      2277304768.0795021, -281723106.32050711, -929592.69858379359, 39150.562041107813, 10423.13689394792, -745.43165711561835, -246.13110512097677, 256.66466950575511,
      -28.138244660695392, -153.75375440915425, 56.498887793223062, 14.096109787623087,
    ]),
    new Float64Array([
      -4448217777.1393995, -112365715.05576693, 1166781.9816626469, 17188.893914572396, 4677.1674859205878, -506.06888655821484, -109.38972702026366, -240.57062975565592,
      -86.506039325396216, 144.9722119728724, 75.239584469795233, 84.061888694763184,
    ])
  ),
  new ChebyshevCoefficients(
    2209032000 as Seconds,
    2366820000 as Seconds,
    new Float64Array([
      -13160618335.332119, 48047132.920313582, 4044386.122805818, -47268.545483684538, -6876.6409383455912, 500.41165358225504, -644.24882882436111, 50.295252354939777,
      -279.9955759366353, -56.198413308461504, 727.81220680872593, 102.13657754262289,
    ]),
    new Float64Array([
      1140501692.2786138, -285965480.0877617, -105118.93280775149, 56880.610648941991, -6635.2945291558899, -516.18235821723943, 67.633192261060074, -96.601746515432993,
      63.393125307559963, -114.81653482516606, -75.600756760438287, 158.77417744398116,
    ]),
    new Float64Array([
      -4876806466.9890938, -101607163.53488208, 1538733.7205325922, 27208.164459371565, -2461.2693964481355, -237.48614724477133, 63.761779054005942, -105.77326908111571,
      -121.52946674029032, 19.256393861770629, 102.38724346160889, -11.303856945037841,
    ])
  ),
  new ChebyshevCoefficients(
    2366820000 as Seconds,
    2493072000 as Seconds,
    new Float64Array([
      -12940631956.651455, 60275449.807884723, 2330004.9745637258, 14829.783176422119, 4767.4463598887123, -411.40955425898233, -1086.6999170303345, 94.066813119252515,
      311.60289745330812, 42.858002249399817, 1225.3523219426472, -42.024418226877849,
    ]),
    new Float64Array([
      110668691.04519799, -228950075.91648048, -74834.404981058833, -18834.190919154884, 2311.0966146806877, 818.23678513367975, -13.826688609520595, -141.86321158210436,
      -113.65252036650975, 26.862501058975855, 21.036616299549738, -1.3419556876023611,
    ]),
    new Float64Array([
      -5223213978.6131907, -72152987.154295087, 998256.54284154577, -8044.3647763729095, 858.54988619486494, 136.67914520899456, -188.19791905085245, 188.23412947654725,
      19.878259849548339, -91.334184169769287, 28.492376677195232, 24.260062138239544,
    ])
  ),
];
